import gameIframe from '@ps/bridge/iframe/iframe'
import { getQuickLayoutComponentNode } from '@ps/bridge/qc/base'
import { scripts } from '@ps/bridge/qc/scripts'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
import { EventBus, Event } from '@ps/utils/event-bus'
import {
  DefaultHighLightBlur,
  DefaultHighLightColor,
  GridAlignType,
  calGoodsNum,
} from '@ps/workbench/undo-redo/module/shelves'
import _ from 'lodash'

const getInitState = () => {
  return {
    dialog: {
      visible: false,
      appendToBody: true,
      modal: true,
      width: '800px',
      top: '88px',
      uuid: '',
      onReplaced: () => {},
    },
    imageSettingDialog: {
      visible: false,
      appendToBody: true,
      modal: false,
      width: '338px',
      top: '128px',
      right: 'calc(666px - 100vw)',
    },
    step: 1,
    scale: 1, // 编辑画布区缩放大小
    sceneNode: null, // 打开编辑面板对应的场景节点
    componentNode: null, // 组件节点
    backupData: null, // 备份数据，用于直接关闭弹窗不保存时还原原来的数据
    historyList: [],
    undoList: [],
    isSelectTool: false,
    isEraseTool: false,
    isGridDrag: false, // 画布编辑区是否拖拽
    disableSubGridEnter: false, // 第三步特定玩法格子mouseEnter事件屏蔽,因为删除关闭图片时会触发到下方的特定玩法格子的enter事件
    editingRes: null,
    hoverGrid: null, // 鼠标悬浮的格子
    hoverSubGrid: null, // 鼠标悬浮的子格子
    bmdCacheList: {}, // 商品外发光BitMapData缓存
    mapData: {
      resourceSelected: null, // 选中的资源
      row: 6,
      column: 3,
      reverseRowCol: false,
      alignType: GridAlignType.Normal,
      gridWidth: 240,
      gridHeight: 120,
      wholeWidth: 720,
      wholeHeight: 720,
      gridData: [], // 格子数据
      gridImage: null,
      shelvesImage: null,
      goodsNumInGrid: 3,
      paddingLeft: 0,
      paddingRight: 0,
      paddingUp: 0,
      paddingDown: 0,
      goodsImageList: [], // 商品图片列表
      weight: false, // 权重开关
      highlight: false, // 商品外发光开关
      highlightBlur: DefaultHighLightBlur, // 外发光模糊值
      highlightColor: DefaultHighLightColor, // 外发光颜色
      highlightPreview: false, // 外发光预览状态
      playFuncGridList: [], // 特定玩法格子列表
      hasReserve: false, // 是否有格子保留设置
      noCloseGrid: false, // 不关闭
      closeGrid: false, // 关闭
      closeGridImage: null, // 关闭图片
      hasRemove: false, // 格子消除
      fall: false, // 掉落
      noFall: false, // 不掉落
      removeReal: false, // 实际值格子消除
      closeReal: false, // 实际值保留时是否关闭
      fallReal: false, // 实际值消除时是否掉落
    },
  }
}

const shelves = {
  namespaced: true,

  state: getInitState(),

  mutations: {
    openDialog(state) {
      this.dispatch('workspace/shelves/readMapDataFromScript')
      state.step = 1
      state.scale = 1
      state.mapData.resourceSelected = null
      state.isSelectTool = false
      state.isEraseTool = true // 第一步默认擦除状态
      state.isGridDrag = false
      state.disableSubGridEnter = false
      state.imageSettingDialog.visible = false
      state.hoverGrid = null
      state.hoverSubGrid = null
      state.bmdCacheList = {}
      state.dialog.visible = true
    },
    closeDialog(state) {
      state.dialog.visible = false
      state.mapData.resourceSelected = null
      state.step = 0
      state.imageSettingDialog.visible = false
      state.bmdCacheList = {}
    },
    openImageSettingDialog(state) {
      state.imageSettingDialog.visible = true
    },
    closeImageSettingDialog(state) {
      state.imageSettingDialog.visible = false
    },
    updateEditingRes(state, value) {
      state.editingRes = value
    },
    updateStep(state, val) {
      state.step = val
      state.isGridDrag = false
      state.disableSubGridEnter = false
      state.isSelectTool = false
      state.isEraseTool = false
      state.mapData.highlightPreview = false
      state.hoverGrid = null
      state.hoverSubGrid = null
    },
    updateSceneNode(state, value) {
      state.sceneNode = value
      state.componentNode = getQuickLayoutComponentNode(state.sceneNode)
    },
    updateIsEraseTool(state, value) {
      state.isEraseTool = value
    },
    updateIsSelectTool(state, value) {
      state.isSelectTool = value
    },
    updateScale(state, value) {
      state.scale = value
    },
    updateIsGridDrag(state, value) {
      state.isGridDrag = value
    },
    updateDisableSubGridEnter(state, value) {
      state.disableSubGridEnter = value
    },
    updateHoverGrid(state, value) {
      state.hoverGrid = value
    },
    updateHoverSubGrid(state, value) {
      state.hoverSubGrid = value
    },
    updateMapData(state, value) {
      state.mapData = Object.assign(state.mapData, value)
      if (value.row || value.column) {
        // 改行列数时清空格子
        this.dispatch('workspace/shelves/clearGridData')
      }
      // 切换格子内商品数时重置gridData的subGrids
      if (value.goodsNumInGrid) {
        for (let i = 0; i < state.mapData.row; i++) {
          for (let j = 0; j < state.mapData.column; j++) {
            state.mapData.gridData[i][j].subGrids = []
            for (let k = 0; k < state.mapData.goodsNumInGrid; k++) {
              state.mapData.gridData[i][j].subGrids.push({
                resId: null,
                playFuncGridId: null,
              })
            }
          }
        }
        calGoodsNum()
      }
      if (value.weight === false) {
        // 关闭权重时清零权重值
        for (const i in state.mapData.goodsImageList) {
          state.mapData.goodsImageList[i].weight = 0
        }
      }
      if (value.highlight === false) {
        // 关闭外发光时发光参数重置默认值
        state.mapData.highlightColor = DefaultHighLightColor
        state.mapData.highlightBlur = DefaultHighLightBlur
      }
      if (
        [
          value.paddingLeft,
          value.paddingRight,
          value.paddingUp,
          value.paddingDown,
          value.highlight,
          value.highlightBlur,
          value.highlightColor,
        ].some((item) => typeof item !== 'undefined')
      ) {
        // 调整内边距和外发光参数时需要重新计算外发光bitmapData
        state.bmdCacheList = {}
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/shelves/addHistory', state.mapData)
    },
    updateMapDataByHistory(state, data) {
      state.mapData = data
    },
    updateMapDataHistory(state) {
      calGoodsNum()
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/shelves/addHistory', state.mapData)
    },
    updateResourceSelected(state, resource) {
      if (resource) {
        state.mapData.resourceSelected = resource
      } else {
        state.mapData.resourceSelected = null
      }
      state.mapData = _.cloneDeep(state.mapData)
      this.dispatch('workspace/shelves/addHistory', state.mapData)
    },
    updateResourceSelectedByAddRes(state, resource) {
      state.mapData.resourceSelected = resource
      state.isSelectTool = true
      state.isEraseTool = false
    },
    updateBmdCacheList(state, value) {
      Object.assign(state.bmdCacheList, value)
    },
  },

  actions: {
    addShelvesNode({ commit, state, dispatch, rootState }, { component }) {
      const currentScene =
        rootState.workspace.game.sceneManager.currentSceneNode
      const shelvesNode = gameIframe.qcGame.add.node()
      const editorData = editorScript.getScript(shelvesNode)
      editorData.$data.nodeType = nodeTypes.shelves
      shelvesNode.name = 'shelves'
      shelvesNode.width = 500
      shelvesNode.height = 500
      shelvesNode.addScript(component)
      currentScene.addChildAt(shelvesNode, currentScene.children.length)
      EventBus.$emit(Event.ADD_GAME_OBJECT, shelvesNode.uuid)
      dispatch(
        'workspace/game/updateActiveNode',
        { node: shelvesNode, record: false },
        {
          root: true,
        },
      )
      this.commit('workspace/game/updateFirstQuickLayoutTip', true)
    },
    initHistory({ state }) {
      state.historyList = []
      state.undoList = []
      const cloneData = _.cloneDeep(state.mapData)
      state.historyList.push(cloneData)
    },
    addHistory({ state }, data) {
      const cloneData = _.cloneDeep(data)
      state.historyList.push(cloneData)
      state.undoList = []
    },
    undoHistory({ state, commit }) {
      if (state.historyList.length <= 1) {
        return
      }
      const data = state.historyList.pop()
      state.undoList.push(data)
      const recoverData = state.historyList[state.historyList.length - 1]
      commit('updateMapDataByHistory', _.cloneDeep(recoverData))
    },
    redoHistory({ state, commit }) {
      if (state.undoList.length === 0) {
        return
      }
      const data = state.undoList.pop()
      state.historyList.push(data)
      const recoverData = state.historyList[state.historyList.length - 1]
      commit('updateMapDataByHistory', _.cloneDeep(recoverData))
    },
    readMapDataFromScript({ state }) {
      const shelvesComponent = state.componentNode.getScript(
        scripts.shelves.name,
      )
      const initValue = getInitState()
      state.mapData = initValue.mapData
      if (
        shelvesComponent.psConfig &&
        Object.keys(shelvesComponent.psConfig).length > 0
      ) {
        state.mapData = _.cloneDeep(shelvesComponent.psConfig)
      } else {
        this.dispatch('workspace/shelves/clearGridData')
      }
    },
    clearGridData({ state }) {
      state.mapData.gridData = []
      for (let i = 0; i < state.mapData.row; i++) {
        const rowItem = []
        for (let j = 0; j < state.mapData.column; j++) {
          const item = {
            x: i,
            y: j,
            active: true,
            subGrids: [
              {
                resId: null,
                playFuncGridId: null,
              },
              {
                resId: null,
                playFuncGridId: null,
              },
              {
                resId: null,
                playFuncGridId: null,
              },
            ], // 默认一个格子里3个子格子
            closeGridImage: null,
          }
          rowItem.push(item)
        }
        state.mapData.gridData.push(rowItem)
      }
      calGoodsNum()
    },
  },
}

export default shelves
